




































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { OpenAPI } from '@/api'

type Headers = Record<string, string>

@Component
export default class Navbar extends Vue {
  mounted (): void {
    OpenAPI.BASE = 'https://prepodam.ru/api/v2'
    OpenAPI.HEADERS = this.getToken
  }

  getToken (): Promise<Headers> {
    return new Promise(resolve => {
      const token = this.$cookies.get('randomAdminId')

      if (token === null || typeof token !== 'string') {
        resolve({})
        return
      }

      resolve({ token })
    })
  }
}
